import { useState } from "react";
import ClientAbonItemMain from "./client-abon-item-main";
import ClientAbonItemStatus from "./client-abon-item-status";
import ClientAbonItemPayments from "./client-abon-item-payments";
import ClientAbonItemPackets from "./client-abon-item-packets";
import { Button, Space, Tabs, message } from "antd";
import { isMobile } from "@/extensions/design";
import ButtonReport from "@/controls/button-report/button-report";
import VisitClientAdd from "../visits/visit-client-add";
   
const { TabPane } = Tabs;
const ClientAbonItem = ({ id, status, onAbonsUpdate, abon }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [showVisitModal, setShowVisitModal] = useState(false);
  // Счётчик обновлений - инкрементируется после открытия визита, чтобы перечитать данные абонемента
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <>
      <div className={!isMobile ? "" : "client-item-content"}>
        <Tabs activeKey={activeTab} onChange={setActiveTab} type="line" className={!isMobile ? "no-custom-tabs" : "no-custom-tabs no-custom-tabs-mobile no-custom-tabs-mobile-client-abons-tabs"}>
          <TabPane tab="Основная" key="1">
            {activeTab === "1" && <ClientAbonItemMain saleId={id} onAbonsUpdate={onAbonsUpdate} refreshKey={refreshKey}/>}
          </TabPane>  
          <TabPane tab="Статус" key="2">
            {activeTab === "2" && <ClientAbonItemStatus id={id} onAbonsUpdate={onAbonsUpdate}/>}
          </TabPane>
          <TabPane tab="Платежи" key="3">
            {activeTab === "3" && <ClientAbonItemPayments id={id} onAbonsUpdate={onAbonsUpdate} abon={abon}/>}
          </TabPane>
          <TabPane tab="Пакеты" key="4">
            {activeTab === "4" && <ClientAbonItemPackets id={id} onAbonsUpdate={onAbonsUpdate}/>}
          </TabPane>
        </Tabs>
        {!  isMobile ? 
        <Space>
          <Button onClick={() => setShowVisitModal(true)} disabled={!id || status !== 2 || abon.productVid !== 2}>Открыть визит</Button>
          <ButtonReport vid={4} id={id} />
        </Space> : 
        <Button type="primary" onClick={() => setShowVisitModal(true)} disabled={!id || status !== 2 || abon.productVid !== 2} style={{width:"100%", marginTop: 4}}>Открыть визит</Button>}
      </div>
      {showVisitModal && (
        <VisitClientAdd
          onClose={(refresh, visitId) => {
            setShowVisitModal(false);
            if (refresh && visitId != null) {
              onAbonsUpdate?.(true);
              // Перечитываем данные абонемента - изменился остаток посещений
              setRefreshKey(prev => prev + 1);
              message.success(`Визит #${visitId} успешно открыт`);
            }
          }}
          defaultClientId={abon?.clientId}
          defaultSaleId={id}
          defaultSaleStatus={status}
          abon={abon}
        />
      )}
    </>
  );
};
export default ClientAbonItem;
